import api from "!../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../node_modules/css-loader/dist/cjs.js??ref--6-1!../node_modules/sass-loader/dist/cjs.js!./colors.css";

var options = {"injectType":"styleTag"};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};